import { render, staticRenderFns } from "./Mailinglist.vue?vue&type=template&id=1cb9bf28&"
import script from "./Mailinglist.vue?vue&type=script&lang=js&"
export * from "./Mailinglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports